<template>
	<div class="promotion-analysis-section">
		<div class="search-area">
			<div class="search-item">
				<span class="label">年份：</span>
				<el-date-picker v-model="promotionAnalysisForm.Year" type="year" placeholder="选择年份" size="small"
					style="width: 130px" value-format="yyyy" :editable="false"></el-date-picker>
			</div>
			<div class="search-item">
				<span class="label">月度区间：</span>
				<el-select v-model="promotionAnalysisForm.MinMonth" placeholder="起始" size="small"
					style="width: 130px" clearable>
					<el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
				</el-select>
				<span style="margin: 0 5px;">-</span>
				<el-select v-model="promotionAnalysisForm.MaxMonth" placeholder="结束" size="small"
					style="width: 130px" clearable>
					<el-option v-for="item in 12" :key="item" :label="item + '月'" :value="item"></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">产品线：</span>
				<el-select v-model="promotionAnalysisForm.InvClass" placeholder="请选择产品线" size="small"
					style="width: 150px" @change="handlePromotionInvClassChange" clearable>
					<el-option v-for="option in productLineOptions" :key="option.value" :label="option.label"
						:value="option.value"></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">LEVEL2：</span>
				<el-select v-model="promotionAnalysisForm.LEVEL2" placeholder="请选择" size="small"
					style="width: 200px" clearable :disabled="!promotionAnalysisForm.InvClass" multiple
					collapse-tags>
					<el-option v-for="item in promotionLevel2Options" :key="item.Value" :label="item.Text"
						:value="item.Value"></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">LEVEL3：</span>
				<el-select v-model="promotionAnalysisForm.LEVEL3" placeholder="请选择" size="small"
					style="width: 200px" clearable :disabled="!promotionAnalysisForm.InvClass" multiple
					collapse-tags>
					<el-option v-for="item in promotionLevel3Options" :key="item.Value" :label="item.Text"
						:value="item.Value"></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">平台：</span>
				<el-select v-model="promotionAnalysisForm.CompanyIDs" placeholder="请选择平台" size="small" filterable clearable
					multiple collapse-tags style="width:322px">
					<el-option v-for="option in firstOrgOptions" :key="option.value" :label="option.label"
						:value="option.value"></el-option>
				</el-select>
			</div>
			<div class="search-item">
				<span class="label">产品名称：</span>
				<el-select style="width: 300px;" v-model="promotionAnalysisForm.InvName" filterable remote
					reserve-keyword placeholder="请输入关键词" size="small" :remote-method="promotionRemoteMethod"
					:loading="promotionProductNameLoading" multiple collapse-tags
					:disabled="!promotionAnalysisForm.InvClass" clearable>
					<el-option v-for="item in promotionProductNameOptions" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="button-group" style="transform: translateY(-4px);">
				<el-button size="small" @click="handlePromotionAnalysisReset">重置</el-button>
				<el-button type="primary" size="small" @click="handlePromotionAnalysisSearch">搜索</el-button>
				<el-button size="small" @click="handlePromotionAnalysisExport">导出</el-button>
			</div>
		</div>

		<div class="content-area" style="background: transparent;box-shadow:none;min-height: auto;">
			<el-card class="chart-card" style="margin-bottom: 20px;">
				<el-spinner v-if="promotionAnalysisLoading" style="margin: 20px auto; display: block;"></el-spinner>
				<div v-else>
					<div v-if="promotionAnalysisChartData && promotionAnalysisChartData.length" class="chart-container" style="display: flex; gap: 10px; width: 100%; overflow-x: auto;">
						<div v-for="(item, index) in promotionAnalysisChartData" :key="index" class="chart-block" style="flex: 1; min-width: 300px; padding: 15px 10px 10px; display: flex; flex-direction: column; position: relative;">
							<div class="chart-totals" style="display: flex; justify-content: space-around; margin-bottom: 0px; position: absolute; width: 100%; top: 20px; left: 0; z-index: 10;">
								<div class="view-amount" style="flex: 1; text-align: center;">
									<span class="amount-label">总额: </span>
									<span class="amount-value">{{ formatPromotionValue(item.CompanyPromotion) }}</span>
								</div>
								<div class="view-amount" style="flex: 1; text-align: center;">
									<span class="amount-label">总额: </span>
									<span class="amount-value">{{ formatPromotionValue(item.OrganizationPromotion) }}</span>
								</div>
							</div>
							<div :ref="'promotionChart' + index" style="width: 100%; height: 350px; margin-top: 20px;"></div>
							<div style="text-align: center; margin-top: 5px; font-weight: 500; color: #333; font-size: 16px;">{{ item.InvClassName }}</div>
						</div>
					</div>
					<el-empty v-else description="暂无图表数据"></el-empty>
				</div>
			</el-card>

			<el-card class="table-card" style="padding: 10px;">
				<div style="width: 100%;">
					<Commontable :isLoading="promotionAnalysisTableLoading" colnum="7"
						:tableData="promotionAnalysisTableData" :headerData="promotionHeaderData">
					</Commontable>
				</div>
				<div class="pagination" style="text-align: right; margin-top: 15px;">
					<Pagination @handleCurrentChange="handlePromotionCurrentChange"
						@handleSizeChange="handlePromotionSizeChange" :pageNo="promotionAnalysisPage.pageIndex"
						:pageSize="promotionAnalysisPage.pageSize" :total="promotionAnalysisPage.total" type="all">
					</Pagination>
				</div>
			</el-card>
		</div>
	</div>
</template>

<script>
import {
	GetInvNameList,
	GetLevel2List,
	GetLevel3List,
	GetFirstOrganization,
	ProductSalesPromotionAnalyse,
	ProductSalesPromotionAnalyseList,
	ProductSalesPromotionAnalyseExport
} from '@/api/newsapi';
import {
	InventoryClassList
} from '@/api/home';
import Commontable from '@/components/common-table.vue';
import Pagination from '@/components/pagination.vue';

export default {
	name: 'ProductSalesPromotionAnalyse',
	components: {
		Commontable,
		Pagination
	},
	data() {
		return {
			productLineOptions: [], // 产品线下拉选项
			// 产品促销分析表单数据
			promotionAnalysisForm: {
				Year: new Date().getFullYear().toString(),
				MinMonth: '',
				MaxMonth: '',
				InvClass: '',
				InvName: [],
				LEVEL2: [],
				LEVEL3: [],
				CompanyIDs: []
			},
			firstOrgOptions: [],
			promotionAnalysisChartData: [],
			promotionAnalysisTableData: [],
			promotionAnalysisLoading: false,
			promotionAnalysisTableLoading: false,
			promotionAnalysisPage: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			promotionLevel2Options: [],
			promotionLevel3Options: [],
			promotionProductNameOptions: [],
			promotionProductNameLoading: false,
			promotionHeaderData: [
				{ prop: 'AbbNameStr', label: '平台', columnwidth: '' },
				{ prop: 'InvNameStr', label: '产品名称', columnwidth: '' },
				{ prop: 'LEVEL2Str', label: 'L2', columnwidth: '' },
				{ prop: 'LEVEL3Str', label: 'L3', columnwidth: '' },
				{ prop: 'CompanyPromotionStr', label: '公司促销', columnwidth: '', types: 'html' },
				{ prop: 'OrganizationPromotionStr', label: '平台促销', columnwidth: '', types: 'html' },
				{ prop: 'PromotionDiff', label: '差额', columnwidth: '', types: 'html' }
			]
		};
	},
	mounted() {
		this.handlePromotionAnalysisSearch();
		// 初始化产品线选项
		this.initProductLineOptions();
		// 初始化一级组织选项(平台)
		this.initFirstOrgOptions();
	},
	methods: {
		// 初始化一级组织选项 (平台)
		initFirstOrgOptions() {
			GetFirstOrganization().then(res => {
				if (res.code === 0) {
					this.firstOrgOptions = res.data.map(item => ({
						value: item.Value,
						label: item.Text
					}));
				}
			}).catch(err => {
				console.error('获取平台列表失败:', err);
			});
		},
		// 初始化产品线选项
		initProductLineOptions() {
			// 调用API获取产品线列表
			InventoryClassList().then(res => {
				if (res.code === 0) {
					this.productLineOptions = res.data.data.map(item => ({
						value: item.InvClass,
						label: item.InvClassName
					}));
				}
			}).catch(err => {
				console.error('获取产品线列表失败:', err);
			});
		},
		// ======= 产品促销分析 methods ========
		handlePromotionInvClassChange() {
			this.promotionAnalysisForm.InvName = [];
			this.promotionAnalysisForm.LEVEL2 = [];
			this.promotionAnalysisForm.LEVEL3 = [];
			this.getPromotionLevel2Options();
			this.getPromotionLevel3Options();
		},
		getPromotionLevel2Options() {
			if (!this.promotionAnalysisForm.InvClass) {
				this.promotionLevel2Options = [];
				return;
			}
			GetLevel2List({ InvClass: this.promotionAnalysisForm.InvClass }).then(res => {
				this.promotionLevel2Options = res.code === 0 ? res.data : [];
			}).catch(() => { this.promotionLevel2Options = []; });
		},
		getPromotionLevel3Options() {
			if (!this.promotionAnalysisForm.InvClass) {
				this.promotionLevel3Options = [];
				return;
			}
			GetLevel3List({ InvClass: this.promotionAnalysisForm.InvClass }).then(res => {
				this.promotionLevel3Options = res.code === 0 ? res.data : [];
			}).catch(() => { this.promotionLevel3Options = []; });
		},
		promotionRemoteMethod(queryString) {
			if (!this.promotionAnalysisForm.InvClass) {
				this.promotionProductNameOptions = [];
				return;
			}
			this.promotionProductNameLoading = true;
			GetInvNameList({
				InvClass: this.promotionAnalysisForm.InvClass,
				InvName: queryString
			}).then(res => {
				this.promotionProductNameOptions = res.code === 0 ? res.data.map(item => ({ value: item.InvName, label: item.InvName })) : [];
			}).catch(() => { this.promotionProductNameOptions = []; })
				.finally(() => { this.promotionProductNameLoading = false; });
		},
		handlePromotionAnalysisReset() {
			this.promotionAnalysisForm = {
				Year: new Date().getFullYear().toString(),
				MinMonth: '',
				MaxMonth: '',
				InvClass: '',
				InvName: [],
				LEVEL2: [],
				LEVEL3: [],
				CompanyIDs: []
			};
			this.promotionProductNameOptions = [];
			this.promotionLevel2Options = [];
			this.promotionLevel3Options = [];
			this.promotionAnalysisPage.pageIndex = 1;
			this.handlePromotionAnalysisSearch();
		},
		getPromotionSearchParams() {
			const params = { ...this.promotionAnalysisForm };
			params.InvName = Array.isArray(params.InvName) && params.InvName.length ? params.InvName.join(',') : '';
			params.LEVEL2 = Array.isArray(params.LEVEL2) && params.LEVEL2.length ? params.LEVEL2.join(',') : '';
			params.LEVEL3 = Array.isArray(params.LEVEL3) && params.LEVEL3.length ? params.LEVEL3.join(',') : '';
			params.CompanyIDs = Array.isArray(params.CompanyIDs) && params.CompanyIDs.length ? params.CompanyIDs.join(',') : '';
			return params;
		},
		handlePromotionAnalysisSearch() {
			this.fetchPromotionChartData();
			this.fetchPromotionTableData();
		},
		fetchPromotionChartData() {
			this.promotionAnalysisLoading = true;
			ProductSalesPromotionAnalyse(this.getPromotionSearchParams()).then(res => {
				let chartData = [];
				if (Array.isArray(res)) {
					chartData = res;
				} else if (res && res.code === 0) {
					if (Array.isArray(res.data)) {
						chartData = res.data;
					} else if (res.data && Array.isArray(res.data.result)) {
						chartData = res.data.result;
					} 
				}
				this.promotionAnalysisChartData = chartData;
			}).catch(err => {
				this.promotionAnalysisChartData = [];
				this.$message.error(err.response?.data?.message || '获取图表数据失败');
			}).finally(() => {
				this.promotionAnalysisLoading = false;
				this.$nextTick(() => {
					if (this.promotionAnalysisChartData && this.promotionAnalysisChartData.length > 0) {
						this.drawPromotionChart();
					}
				});
			});
		},
		fetchPromotionTableData() {
			this.promotionAnalysisTableLoading = true;
			const params = {
				...this.getPromotionSearchParams(),
				PageIndex: this.promotionAnalysisPage.pageIndex,
				PageSize: this.promotionAnalysisPage.pageSize
			};
			ProductSalesPromotionAnalyseList(params).then(res => {
				let list = [];
				let total = 0;

				if (Array.isArray(res)) {
					list = res;
					total = res.length;
				} else if (res && res.code === 0) {
					if (Array.isArray(res.data)) {
						list = res.data;
						total = res.data.length;
					} else if (res.data) {
						list = res.data.result || res.data.list || res.data.data || res.data.Data || [];
						total = res.data.Count || res.data.total || res.data.count || res.data.Total || list.length || 0;
					}
				}

				// 预处理数据供 Commontable 渲染
				this.promotionAnalysisTableData = list.map(item => {
					const diffVal = item.Diff !== undefined ? item.Diff : item.diff;
					return {
						...item,
						AbbNameStr: item.AbbName || item.abbName,
						InvNameStr: item.InvName || item.invName,
						LEVEL2Str: item.LEVEL2 || item.level2,
						LEVEL3Str: item.LEVEL3 || item.level3,
						CompanyPromotionStr: this.formatPromotionValueHTML(item.CompanyPromotion !== undefined ? item.CompanyPromotion : item.companyPromotion),
						OrganizationPromotionStr: this.formatPromotionValueHTML(item.OrganizationPromotion !== undefined ? item.OrganizationPromotion : item.organizationPromotion),
						PromotionDiff: this.formatPromotionValueHTML(diffVal),
						Diff: diffVal // 保留原始 Diff 用于判断颜色
					};
				});
				this.promotionAnalysisPage.total = total;
			}).catch(err => {
				this.promotionAnalysisTableData = [];
				this.promotionAnalysisPage.total = 0;
				this.$message.error(err.response?.data?.message || '获取列表数据失败');
			}).finally(() => {
				this.promotionAnalysisTableLoading = false;
			});
		},
		handlePromotionSizeChange(val) {
			this.promotionAnalysisPage.pageSize = val;
			this.promotionAnalysisPage.pageIndex = 1;
			this.fetchPromotionTableData();
		},
		handlePromotionCurrentChange(val) {
			this.promotionAnalysisPage.pageIndex = val;
			this.fetchPromotionTableData();
		},
		handlePromotionAnalysisExport() {
			const params = this.getPromotionSearchParams();
			ProductSalesPromotionAnalyseExport(params).then(res => {
				const blob = new Blob([res]);
				const fileName = '产品促销分析表.xlsx';
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = fileName;
				link.click();
				window.URL.revokeObjectURL(link.href);
			}).catch(err => {
				this.$message.error('导出失败');
			});
		},
		formatPromotionValue(val) {
			if (val === null || val === undefined || val === '') return '';
			const num = Number(val);
			if (isNaN(num)) return val;
			return Math.round(num).toLocaleString();
		},
		formatPromotionValueHTML(val) {
			if (val === null || val === undefined || val === '') return '';
			const num = Number(val);
			if (isNaN(num)) return val;
			const formatted = Math.round(num).toLocaleString();
			if (num < 0) {
				return `<span style="color: #ff4d4f;">${formatted}</span>`;
			}
			return formatted;
		},
		drawPromotionChart() {
			this.$nextTick(() => {
				this.promotionAnalysisChartData.forEach((chartItem, index) => {
					const domArray = this.$refs['promotionChart' + index];
					if (!domArray) return;
					const dom = Array.isArray(domArray) ? domArray[0] : domArray;
					if (!dom) return;

					let myChart = this.$MyEcharts.getInstanceByDom(dom);
					if (myChart) {
						myChart.dispose();
					}
					myChart = this.$MyEcharts.init(dom);

					const customColors = [
						// 1. 莫兰迪蓝
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#9EBCF2' }, { offset: 1, color: '#6A99E5' }] } },
						// 2. 莫兰迪绿
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#AEE0BE' }, { offset: 1, color: '#88C999' }] } },
						// 3. 莫兰迪黄
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#F7D89C' }, { offset: 1, color: '#F1C46E' }] } },
						// 4. 莫兰迪红
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#F0B3A8' }, { offset: 1, color: '#E58A7A' }] } },
						// 5. 莫兰迪青
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#A8E1F2' }, { offset: 1, color: '#7CCCE5' }] } },
						// 6. 莫兰迪紫
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#C2B2E0' }, { offset: 1, color: '#9E88C9' }] } },
						// 7. 莫兰迪橙
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#F7C899' }, { offset: 1, color: '#F2A663' }] } },
						// 8. 莫兰迪深青
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#8EBFBF' }, { offset: 1, color: '#60A6A6' }] } },
						// 9. 莫兰迪粉
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#F0C2D6' }, { offset: 1, color: '#E599B8' }] } },
						// 10. 莫兰迪灰蓝
						{ color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#B0B8C4' }, { offset: 1, color: '#818B99' }] } }
					];

					const series = [];
					if (chartItem.promotion && chartItem.promotion.length) {
						chartItem.promotion.forEach((prod, pIdx) => {
							const customStyle = customColors[pIdx % customColors.length];
							series.push({
								name: prod.InvName,
								type: 'bar',
								stack: 'total',
								barWidth: 50,
								data: [
									{ value: prod.CompanyPromotion, diff: prod.Diff },
									{ value: prod.OrganizationPromotion, diff: prod.Diff }
								],
								itemStyle: {
									color: customStyle.color
								}
							});
						});
					}

					const option = {
						tooltip: {
							trigger: 'item',
							formatter: function(params) {
								const prod = chartItem.promotion.find(p => p.InvName === params.seriesName);
								if (!prod) return '';

								let res = `<div style="font-weight:bold;margin-bottom:4px;">${prod.InvName}</div>`;
								res += `<div><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#E71D43;"></span>公司促销: ${(prod.CompanyPromotion / 10000).toFixed(2)} 万元</div>`;
								res += `<div><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#00266D;"></span>平台促销: ${(prod.OrganizationPromotion / 10000).toFixed(2)} 万元</div>`;
								res += `<div><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#999;"></span>差额: ${(prod.Diff / 10000).toFixed(2)} 万元</div>`;
								return res;
							}
						},
						grid: {
							left: '10%',
							right: '10%',
							top: '15%',
							bottom: '10%',
							containLabel: true
						},
						xAxis: {
							type: 'category',
							data: ['公司促销', '平台促销'],
							axisTick: { show: false },
							axisLine: { show: true, lineStyle: { color: '#666', width: 2 } },
							axisLabel: { color: '#333', fontSize: 14 }
						},
						yAxis: {
							type: 'value',
							name: '万元',
							axisLabel: {
								show: true,
								formatter: function(value) {
									return (value / 10000).toFixed(0);
								}
							},
							splitLine: {
								show: true,
								lineStyle: { color: '#eeeeee' }
							},
							axisTick: { show: false },
							axisLine: {
								show: true,
								symbol: ['none', 'arrow'],
								symbolSize: [8, 12],
								lineStyle: { color: '#666', width: 2 }
							}
						},
						series: series
					};

					myChart.setOption(option);
					window.addEventListener("resize", () => {
						myChart.resize();
					});
				});
			});
		}
	}
}
</script>

<style scoped>
.promotion-analysis-section {
	/* margin-bottom: 20px; */
}

.search-area {
	background-color: #fff;
	padding: 20px;
	border-radius: 4px;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 15px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-item {
	margin-right: 15px;
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}

.label {
	margin-right: 10px;
	font-size: 14px;
	color: #606266;
}

.button-group {
	margin-left: auto;
}

.button-group .el-button {
	margin-left: 10px;
}

.content-area {
	min-height: 400px;
	background: #FFFFFF;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.chart-card {
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

::v-deep .el-select__input.is-small {
	border: none !important;
}

::v-deep .el-input__inner,
::v-deep .el-textarea__inner,
::v-deep .el-select .el-input__inner,
::v-deep .el-date-editor.el-input__inner {
	transition: all 0.8s;
	border-radius: 0px;
}

::v-deep .el-input__inner:focus,
::v-deep .el-textarea__inner:focus,
::v-deep .el-select.is-focus .el-input__inner,
::v-deep .el-date-editor.is-focus .el-input__inner {
	border: 1px solid #e71d43 !important;
}

/* 保证表格在无数据时有最小高度，以完整显示 loading */
::v-deep .el-table__empty-block {
	min-height: 400px;
}

.view-amount {
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	padding: 0 12px;
}

.view-amount .amount-label {
	font-size: 12px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #333333;
}

.view-amount .amount-value {
	font-size: 16px;
	font-family: D-DIN-Bold, D-DIN;
	font-weight: 700;
	line-height: 24px;
	letter-spacing: 1px;
	background: linear-gradient(180deg, rgba(27, 126, 242, 0.48) 0%, #1B7EF2 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	margin: 0px 4px;
}
</style>
